import { View } from "../index";
import { BaseApp } from "../../app";

/**
 * View post processor.
 */
export abstract class ViewProcessor
{
    public beforeRender(view: View): PromiseLike<void>
    {
        return Promise.resolve();
    }
    public afterRender(view: View): PromiseLike<void>
    {
        return Promise.resolve();
    }
}

export interface ViewProcessorConstructor
{
    new (): ViewProcessor;
}

export default class ViewProcessorManager
{
    private app: BaseApp;

    constructor(app: BaseApp)
    {
        this.app = app;
        this.processors = [];
    }
    
    private processors: ViewProcessor[];

    public add(processor: ViewProcessorConstructor): void
    {
        let instance = new processor();
        this.processors.push(instance);
    }

    public beforeRender(view: View): PromiseLike<void[]>
    {
        return Promise.all(this.processors.map(p => p.beforeRender(view)));
    }

    public afterRender(view: View): PromiseLike<void[]>
    {
        return Promise.all(this.processors.map(p => p.afterRender(view)));
    }
}